import { createFileRoute } from "@tanstack/react-router";
import { TutorsSavedPage } from "@/components/partners/TutorsSavedPage";
import { tutorsSavedHead } from "@/components/partners/tutors-saved-head";
import { loadTutorsHub } from "@/components/partners/partner-route";

// ♥ Сохранённые анкеты карты (az): список браузера или ?ids= из WhatsApp. noindex, в sitemap нет.
export const Route = createFileRoute("/az/tutors/saved")({
  loader: () => loadTutorsHub(),
  head: () => tutorsSavedHead("az"),
  component: function Page() {
    const { list } = Route.useLoaderData();
    return <TutorsSavedPage lang="az" initial={list} />;
  },
});
